import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_PeriodicStaffingRevOfIsp = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_PeriodicStaffingRevOfIsp' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <b>Periodic Staffing/Review of the Individual Service Plan</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Change in diagnosis since last review:</span>
                    <textarea id='txtChangeDiagnosis' name='txtChangeDiagnosis' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Change in symptoms since last review:</span>
                    <textarea id='txtChangeSymptoms' name='txtChangeSymptoms' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Change(s) in service activities since last review:</span>
                    <textarea id='txtChangeServiceActivities' name='txtChangeServiceActivities' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Change(s) in household since last review:</span>
                    <textarea id='txtChangeHoushold' name='txtChangeHoushold' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Change(s) in treatment/service recommendations since last review:</span>
                    <textarea id='txtChangeTreatment' name='txtChangeTreatment' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other significant life change(s) since last review:</span>
                    <textarea id='txtOtherSignificant' name='txtOtherSignificant' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Comments/Recommendation:</span>
                    <textarea id='txtCommentsRecommendation' name='txtCommentsRecommendation' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Plan Modification:</span>
                    <input type='radio' id='rbPlanModification_Yes' name='rbPlanModification' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPlanModification_No' name='rbPlanModification' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbPlanModification_RewritePlan' name='rbPlanModification' className='add-only' value='RewritePlan' /> Rewrite Plan
                </p>

                <p className='w-750'>
                    If yes, make additions/ modifications to the existing plan
                    <textarea id='txtModificationsToTheExistingPlan' name='txtModificationsToTheExistingPlan' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-450'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-450'>Individual Receiving Services :</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-450'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-450'>Staff Signatures/Credentials :</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-450'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-450'>Staff Signatures/Credentials :</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-450'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-450'>Signature of Parent/Legal Guardian (if applicable) :</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











